import React from 'react'

type InputProps = {
  value: string | boolean | number
  onChange: (value: any) => void
  className?: string
}

export default function Input(props: InputProps & {[k: string]: any}) {
  const {value, onChange, ...additionalProps} = props
  const type = additionalProps.type || 'text'
  const valueName: any = {
    checkbox: 'checked',
  }
  const valueSelector = valueName[type] ?? 'value'
  const inputProps = {
    [valueSelector]: value,
  }

  return (
    <input
      {...inputProps}
      onChange={(event) => {
        onChange((event.target as any)[valueSelector])
      }}
      {...additionalProps}
    />
  )
}
